import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col, Button, FormGroup, Label } from 'reactstrap';
import { connect } from 'react-redux';
import * as actionsRedux from '../../../Store/Actions/index';
import InputForm from '../../Form/InputForm';
import SelectForm from '../../Form/SelectForm';
import { axiosApi } from '../../axiosInstances';
import './style.css';
import '../../../css/linhaSeparadoraGrupo.css';
import NewLoader from '../../NewLoader';
import ModalCritiaGrupos from '../../../Modal/ModalCritiaGrupos';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

const ModalGruposAlunoServico = ({
    isOpen,
    setIsOpen,
    ativar,
    setGruposAlunoServico,
    grupoAlunoId
}) => {
    const style = {
        col4: { xs: 6, md: 3, sm: 3, lg: 3, xl: 3 },
        col6: { xs: 6, md: 2, sm: 2, lg: 2, xl: 2 }
    };

    const [isLoading, setIsLoading] = useState(true);
    const [qtdCampos, setQtdCampos] = useState();
    const [gruposOptions, setGruposOptions] = useState([]);
    const [gruposOptionsDisponiveis, setGruposOptionsDisponiveis] = useState([]);
    const [semestresOptions, setSemestresOptions] = useState([]);
    const [periodosLetivosOptions, setPeriodosLetivosOptions] = useState([]);
    const [turmasOptions, setTurmasOptions] = useState([]);
    const [chasOptions, setChasOptions] = useState([{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }]);
    const [professoresOptions, setProfessoresOptions] = useState([]);
    const [locaisOptions, setLocaisOptions] = useState([]);
    const [professores, setProfessores] = useState([]);
    const [locais, setLocais] = useState([]);
    const [readTurma, setReadTurma] = useState(true);
    const [modalCritica, setModalCritica] = useState(false);
    const [dados, setDados] = useState([]);
    const [valoresFiltro, setValoresFiltro] = useState({
        semestre_id: undefined,
        turma_id: undefined,
        qtd_alunos: 0,
        cha: undefined
    });

    // Estado para armazenar os grupos de alunos
    const [gruposAlunos, setGruposAlunos] = useState([]);

    const toggle = () => {
        setIsLoading(false)
        setValoresFiltro({
            semestre_id: undefined,
            turma_id: undefined,
            qtd_alunos: 0
        });
        setGruposAlunos([]);
        setGruposOptions([]);
        setIsOpen(!isOpen);
    };

    const toggleModalCritica = () => {
        setModalCritica(!modalCritica);
    };

    const getProfessores = async (semestreId) => {
        try {
            let params = {
                semestre_id: semestreId,
            };
            const response = await axiosApi({
                method: "get",
                url: `/auxiliares/professores-cha`,
                params: params ? params : {}
            })
            setProfessoresOptions(response.data.map(element => ({ label: element.nome_social, value: element.id })));
        } catch (error) {
            console.log(error);
        }
    };

    const getLocais = async () => {
        try {
            const response = await axiosApi({
                method: "get",
                url: `/locais`,
            })
            setLocaisOptions(response.data.dados.map(element => ({ label: element.nome, value: element.id })));
        } catch (error) {
            console.log(error);
        }
    };

    const adicionarLinhaProfessorLocal = (grupoIndex) => {
        setProfessores(prev => {
            const novo = Array.isArray(prev) ? [...prev] : [];
            const linhasGrupo = Array.isArray(novo[grupoIndex]) ? [...novo[grupoIndex]] : [];
            linhasGrupo.push({ professor_id: undefined, local_id: undefined });
            novo[grupoIndex] = linhasGrupo;
            return novo;
        });
    };

    const removerLinhaProfessorLocal = (grupoIndex, linhaIndex) => {
        setProfessores(prev => {
            const novo = Array.isArray(prev) ? [...prev] : [];
            const linhasGrupo = Array.isArray(novo[grupoIndex]) ? [...novo[grupoIndex]] : [];
            if (linhasGrupo.length <= 1) {
                linhasGrupo[0] = { professor_id: undefined, local_id: undefined };
            } else {
                linhasGrupo.splice(linhaIndex, 1);
            }
            novo[grupoIndex] = linhasGrupo;
            return novo;
        });
    };

    const atualizarLinhaProfessorLocal = (grupoIndex, linhaIndex, campo, valor) => {
        setProfessores(prev => {
            const novo = Array.isArray(prev) ? [...prev] : [];
            const linhasGrupo = Array.isArray(novo[grupoIndex]) ? [...novo[grupoIndex]] : [];
            if (!linhasGrupo[linhaIndex]) {
                linhasGrupo[linhaIndex] = { professor_id: undefined, local_id: undefined };
            }
            linhasGrupo[linhaIndex] = {
                ...linhasGrupo[linhaIndex],
                [campo]: valor
            };
            novo[grupoIndex] = linhasGrupo;
            return novo;
        });
    };

    const onChange = (nome, valor, indice, ultimoValor, action) => {
        switch (nome) {
            case 'professores':
                setProfessores(prev => {
                    const novo = Array.isArray(prev) ? [...prev] : [];
                    novo[indice] = Array.isArray(valor) ? valor : [valor];
                    return novo;
                });
                break;
            case 'periodo_letivo_id':
                setValoresFiltro({ ...valoresFiltro, periodo_letivo_id: valor });
                break;
            case 'semestre_id':
                setValoresFiltro({ ...valoresFiltro, semestre_id: valor });
                getTurmas(valor);
                break;
            case 'turma_id':
                setValoresFiltro({ ...valoresFiltro, turma_id: valor });
                getAlunos(valor);
                break;
            case 'locais':
                setLocais(prev => {
                    const novo = Array.isArray(prev) ? [...prev] : [];
                    // Se valor for array (multi-select), pega o primeiro id ou null; se não, usa o valor diretamente
                    novo[indice] = Array.isArray(valor) ? valor[0] : valor;
                    return novo;
                });
                break;
            case 'cha':
                setValoresFiltro({ ...valoresFiltro, cha: valor });
                if (valor == 1) {
                    getProfessores(valoresFiltro.semestre_id);
                    getLocais();
                }
                break;
            case 'qtd_alunos':
                if (valor == '') {
                    setValoresFiltro({ ...valoresFiltro, qtd_alunos: valor });
                    setQtdCampos(undefined);
                    setGruposAlunos([]);
                    setGruposOptionsDisponiveis(gruposOptions)
                } else {
                    setValoresFiltro({ ...valoresFiltro, qtd_alunos: valor });
                    // Calcular a nova quantidade de campos sem perder os grupos existentes
                    let novoQtdCampos = Math.ceil(gruposOptions?.length / valor);

                    // Encontrar o índice do último grupo que possui alunos
                    let ultimoGrupoComAlunos = -1;
                    gruposAlunos.forEach((grupo, idx) => {
                        if (Array.isArray(grupo) && grupo.length > 0) {
                            ultimoGrupoComAlunos = idx;
                        }
                    });

                    // Garantir que não removemos grupos que possuem alunos
                    if (ultimoGrupoComAlunos >= 0) {
                        novoQtdCampos = Math.max(novoQtdCampos, ultimoGrupoComAlunos + 1);
                    }

                    setQtdCampos(novoQtdCampos);

                    // Manter os grupos existentes
                    if (gruposAlunos.length === 0) {
                        // Se não houver grupos ainda, criar novos
                        setGruposAlunos(new Array(novoQtdCampos).fill([]));
                    } else if (gruposAlunos.length < novoQtdCampos) {
                        // Se precisar adicionar mais campos, preservar os existentes e adicionar novos vazios
                        setGruposAlunos([...gruposAlunos, ...new Array(novoQtdCampos - gruposAlunos.length).fill([])]);
                    }

                    // Filtrar as opções disponíveis para remover alunos que já estão em algum grupo
                    const alunosJaSelecionados = [];
                    gruposAlunos.forEach(grupo => {
                        if (Array.isArray(grupo)) {
                            alunosJaSelecionados.push(...grupo);
                        }
                    });

                    // Remover alunos já selecionados das opções disponíveis
                    const opcoesDisponiveis = gruposOptions.filter(
                        option => !alunosJaSelecionados.includes(option.value)
                    );

                    setGruposOptionsDisponiveis(opcoesDisponiveis);
                }
                break;
            case 'alunos':
                if (action == "clear") {
                    // Quando limpar o grupo, adicionar todos os alunos desse grupo às opções disponíveis
                    const filtrados = gruposOptions.filter(grupo => gruposAlunos[indice].includes(grupo.value));
                    setGruposOptionsDisponiveis(prevState => {
                        return [...prevState, ...filtrados];
                    });
                    setGruposAlunos(prevState =>
                        prevState.map((grupo, index) =>
                            index === indice ? [] : grupo
                        )
                    );
                } else {
                    // Identificar qual valor foi removido (se foi uma remoção)
                    const difference = gruposAlunos?.[indice]?.filter(item => !valor.includes(item))[0];
                    const grupoCorrespondente = gruposOptions.find(grupo => grupo.value === difference);

                    // Garante que `selectedAlunos` é uma array
                    const selectedAlunos = Array.isArray(valor) ? valor : [valor];

                    // Verifica se o limite de alunos foi atingido
                    if (selectedAlunos.length > valoresFiltro.qtd_alunos) {
                        ativar(400, "Limite de aluno por grupo atingido!");
                    } else {
                        // Caso `difference` seja `undefined` e `action` seja `remove-value`
                        if (difference === undefined && action === 'remove-value') {
                            // Limpa o grupo no índice especificado
                            const alunosASeremLiberados = gruposAlunos[indice] || [];

                            // Adiciona os alunos removidos de volta às opções disponíveis
                            if (alunosASeremLiberados.length > 0) {
                                const opcoesALiberar = gruposOptions.filter(
                                    option => alunosASeremLiberados.includes(option.value)
                                );

                                setGruposOptionsDisponiveis(prevState => [
                                    ...prevState,
                                    ...opcoesALiberar
                                ]);
                            }

                            // Limpa o grupo
                            setGruposAlunos(prevState =>
                                prevState.map((grupo, index) =>
                                    index === indice ? [] : grupo
                                )
                            );
                        } else {
                            // Capturar os alunos que foram adicionados nesta operação
                            const alunosAnteriores = gruposAlunos[indice] || [];
                            const alunosAdicionados = selectedAlunos.filter(
                                aluno => !alunosAnteriores.includes(aluno)
                            );

                            // Adiciona `selectedAlunos` ao grupo no índice especificado
                            setGruposAlunos(prevState => {
                                const newState = [...prevState];
                                newState[indice] = selectedAlunos;
                                return newState;
                            });

                            // Atualiza as opções disponíveis
                            if (action === "remove-value" && grupoCorrespondente) {
                                // Adiciona a opção removida de volta ao array de opções disponíveis
                                setGruposOptionsDisponiveis(prevState => [
                                    ...prevState,
                                    { value: grupoCorrespondente.value, label: grupoCorrespondente.label }
                                ]);
                            } else if (alunosAdicionados.length > 0) {
                                // Remove os alunos recém-adicionados das opções disponíveis
                                setGruposOptionsDisponiveis(prevState =>
                                    prevState.filter(option => !alunosAdicionados.includes(option.value))
                                );
                            }
                        }
                    }
                }
            default:
                break;
        }
    };

    const getTurmas = async (semestreId) => {
        try {
            const { data } = await axiosApi.get(`/auxiliares/turmas-semestre?semestre_id=${semestreId}&periodo_letivo_id=${valoresFiltro.periodo_letivo_id}`);
            setTurmasOptions(data.map(element => ({ label: element.descricao, value: element.id })));
            ativar(201, "Turmas carregadas com sucesso!");
            setReadTurma(false);
        } catch (error) {
            setReadTurma(true);
            ativar(400, error?.response.data.erro);
        }
    };

    // Função para atualizar as opções disponíveis com base nos grupos de alunos atuais
    const atualizarOpcoesDisponiveis = (todasOpcoes, grupos) => {
        // Coletar todos os IDs de alunos que já estão em algum grupo
        const alunosJaSelecionados = [];
        if (Array.isArray(grupos)) {
            grupos.forEach(grupo => {
                if (Array.isArray(grupo)) {
                    alunosJaSelecionados.push(...grupo);
                }
            });
        }

        // Filtrar as opções disponíveis para remover alunos que já estão em algum grupo
        return todasOpcoes.filter(option => !alunosJaSelecionados.includes(option.value));
    };

    const getAlunos = async (turmaId) => {
        try {
            const { data } = await axiosApi.get(`/auxiliares/grupos-semestre-turma?semestre_id=${valoresFiltro.semestre_id}&turma_id=${turmaId}&periodo_letivo_id=${valoresFiltro.periodo_letivo_id}`);
            const opcoes = data.map(element => ({ label: element.descricao, value: element.id }));
            setGruposOptions(opcoes);

            // Filtrar opções disponíveis para excluir alunos já selecionados
            const opcoesDisponiveis = atualizarOpcoesDisponiveis(opcoes, gruposAlunos);
            setGruposOptionsDisponiveis(opcoesDisponiveis);
        } catch (error) {
            console.log(error);
        }
    };

    const getFiltros = async () => {
        try {
            if (isOpen) {
                setIsLoading(true);
                const { data } = await axiosApi.get('/auxiliares/filtros-grupos-aluno');
                setPeriodosLetivosOptions(data.periodo_letivo.map(element => ({ label: element.descricao, value: element.id })));
                setSemestresOptions(data.semestres.map(element => ({ label: element.descricao, value: element.id })));

                if (grupoAlunoId != null) {
                    const { data } = await axiosApi.get(`/auxiliares/grupos-aluno/${grupoAlunoId}`);
                    getProfessores(data.dados.semestre_id);
                    getLocais();
                    // Carregar os grupos de alunos
                    const gruposCarregados = data.grupos_aluno;
                    setGruposAlunos(gruposCarregados);

                    setValoresFiltro({
                        semestre_id: data.dados.semestre_id,
                        turma_id: data.dados.turma_id,
                        qtd_alunos: data.dados.qtd_alunos,
                        periodo_letivo_id: data.dados.periodo_letivo_id,
                        cha: data.is_cha ? 1 : 0
                    });
                    setLocais(data.locais);
                    setProfessores(data.professores);
                    setTurmasOptions(data.turmas.map(element => ({ label: element.descricao, value: element.id })));

                    // Configurar todas as opções de grupos
                    const todasOpcoes = data.grupos.map(element => ({ label: element.descricao, value: element.id }));
                    setGruposOptions(todasOpcoes);

                    // Definir quantidade de campos
                    let novoQtdCampos = data.qtd_campos;
                    if (!novoQtdCampos && data.dados.qtd_alunos > 0) {
                        novoQtdCampos = Math.ceil(todasOpcoes.length / data.dados.qtd_alunos);
                    }
                    if (Array.isArray(gruposCarregados)) {
                        novoQtdCampos = Math.max(novoQtdCampos || 0, gruposCarregados.length);
                    }
                    setQtdCampos(novoQtdCampos);

                    // Coletar todos os IDs de alunos que já estão em algum grupo
                    const alunosJaSelecionados = [];
                    if (Array.isArray(gruposCarregados)) {
                        gruposCarregados.forEach(grupo => {
                            if (Array.isArray(grupo)) {
                                alunosJaSelecionados.push(...grupo);
                            }
                        });
                    }

                    // Filtrar as opções disponíveis para remover alunos que já estão em algum grupo
                    const opcoesDisponiveis = todasOpcoes.filter(
                        option => !alunosJaSelecionados.includes(option.value)
                    );

                    setGruposOptionsDisponiveis(opcoesDisponiveis);
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const salvar = async () => {
        try {
            let infos = valoresFiltro;
            infos.itens = gruposAlunos;
            const todosLocaisFlat = [];
            professores.forEach(grupo => {
                if (Array.isArray(grupo)) {
                    grupo.forEach(p => {
                        if (p && p.local_id) todosLocaisFlat.push(p.local_id);
                    });
                }
            });
            infos.locais = todosLocaisFlat;
            const response = await axiosApi.post(`/verificar-sequencia-grupos`, infos);
            if (response.data.dados.length > 0) {
                setDados(response.data);
                setModalCritica(true);
            } else {
                salvarAtualizarGrupos();
            }
        } catch (error) {
            console.log(error);
        }
    }

    const salvarAtualizarGrupos = async () => {
        let infos = valoresFiltro;
        infos.itens = gruposAlunos;
        infos.locais = [];
        if (professores.length > 0) {
            infos.professores = professores.map(grupo =>
                Array.isArray(grupo)
                    ? grupo.filter(p => p && p.professor_id !== undefined && p.professor_id !== null && p.professor_id !== "")
                    : []
            );
        }
        if (grupoAlunoId != null) {
            const response = await axiosApi.put(`/auxiliares/grupos-aluno/${grupoAlunoId}`, infos);
            ativar(200, "Grupos editado com sucesso!");
            setGruposAlunoServico(prevGrupos =>
                prevGrupos.map(grupo =>
                    grupo.id === response.data.id ? response.data : grupo
                )
            );
        } else {
            const response = await axiosApi.post('/auxiliares/grupos-aluno', infos);
            ativar(200, "Grupos adicionado com sucesso!");
            setGruposAlunoServico(prevGrupos => [...prevGrupos, response.data]);
        }
    }

    const atualizarGrupos = (atualizar) => {
        try {
            let infos = valoresFiltro;
            infos.itens = gruposAlunos;
            if (atualizar) {
                salvarAtualizarGrupos();
            } else {
                toggleModalCritica();
            }
        } catch (error) {
            console.log(error);
        }
        finally {
            toggleModalCritica();
            toggle();
        }
    }

    useEffect(() => {
        getFiltros();
    }, [isOpen]);

    return (
        <NewLoader isActive={isLoading} overlay >
            <Modal isOpen={isOpen} toggle={toggle} size='xl'>
                <ModalHeader>
                    <h4>
                        <b>Grupos de Aluno Serviço</b>
                    </h4>
                </ModalHeader>
                <ModalBody>
                    <Row className="modal-grupos-aluno">
                        <SelectForm
                            label="Período Letivo"
                            name="periodo_letivo_id"
                            placeholder="Selecione"
                            options={periodosLetivosOptions}
                            value={periodosLetivosOptions?.find(option => option.value === valoresFiltro.periodo_letivo_id) || ''}
                            onChange={onChange}
                            style={{ col: style.col3 }}
                        />
                        <SelectForm
                            label="Semestre"
                            name="semestre_id"
                            placeholder="Selecione"
                            options={semestresOptions}
                            value={semestresOptions?.find(option => option.value === valoresFiltro.semestre_id) || ''}
                            onChange={onChange}
                            style={{ col: style.col3 }}
                        />
                        <SelectForm
                            label="Turma"
                            name="turma_id"
                            placeholder="Selecione"
                            options={turmasOptions}
                            value={turmasOptions?.find(option => option.value === valoresFiltro.turma_id) || ''}
                            onChange={onChange}
                            style={{ col: style.col3 }}
                            readOnly={readTurma}
                        />
                        <InputForm
                            type="number"
                            name="qtd_alunos"
                            label="Quantidade de Alunos"
                            value={valoresFiltro.qtd_alunos}
                            onChange={onChange}
                            style={{ col: style.col3 }}
                        />

                        {
                            (valoresFiltro?.semestre_id == 8 || valoresFiltro?.semestre_id == 9) && (
                                <SelectForm
                                    label="CHA"
                                    name="cha"
                                    placeholder="Selecione"
                                    options={chasOptions}
                                    value={chasOptions?.find(option => option.value === valoresFiltro.cha) || ''}
                                    onChange={onChange}
                                    style={{ col: style.col3 }}
                                    readOnly={readTurma}
                                />
                            )}
                    </Row>
                    <Row className={valoresFiltro?.qtd_alunos !== 0 ? 'exibir' : 'nao-exibir'}>
                        {Array.from({ length: qtdCampos }, (_, index) => (
                            <Col xs={12} key={index} className="mb-2">
                                <SelectForm
                                    key={index}
                                    isMulti
                                    indice={index}
                                    label={`Grupo ${index + 1}`}
                                    name="alunos"
                                    placeholder="Selecione"
                                    options={gruposOptionsDisponiveis}
                                    value={gruposOptions?.filter(option => gruposAlunos?.[index]?.includes(option.value)) || ''}
                                    onChange={onChange} // Passa o índice e o valor selecionado
                                    style={{
                                        col: {
                                            xs: 12,
                                            sm: 12,
                                            md: 12,
                                            lg: 12,
                                            xl: 12
                                        }
                                    }}
                                />
                                <div className="d-flex justify-content-end w-100 pr-3">
                                    <h1 className={`numeracao-alunos-grupo ${(gruposAlunos?.[index]?.length ?? 0) > valoresFiltro?.qtd_alunos ? 'texto-aviso' : ''}`} style={{ marginTop: '-0.5rem', marginBottom: '0.5rem' }}>
                                        {`${gruposAlunos?.[index]?.length ?? 0}/${valoresFiltro?.qtd_alunos}`}
                                        {(gruposAlunos?.[index]?.length ?? 0) > valoresFiltro?.qtd_alunos &&
                                            <span className='icone-aviso' title='O grupo excede o limite de alunos definido'>⚠️</span>}
                                    </h1>
                                </div>
                                {
                                    (valoresFiltro?.semestre_id == 8 || valoresFiltro?.semestre_id == 9) && valoresFiltro?.cha == 1 && (() => {
                                        const linhasGrupo = professores[index] && professores[index].length > 0 ? professores[index] : [{ professor_id: undefined, local_id: undefined }];
                                        return (
                                            <div className="professor-local-cha-container w-100 mb-3">
                                                {linhasGrupo.map((linha, subIndex) => (
                                                    <Row key={subIndex} className="professor-local-cha align-items-center mb-2 no-gutters">
                                                        <Col className="pr-2" style={{ flex: '1 0 0%' }}>
                                                            <SelectForm
                                                                label={`Professor ${subIndex + 1}`}
                                                                name={`professor_id_${index}_${subIndex}`}
                                                                placeholder="Selecione o Professor"
                                                                options={professoresOptions}
                                                                value={professoresOptions?.find(option => option.value == linha.professor_id) || ''}
                                                                onChange={(nome, valor) => atualizarLinhaProfessorLocal(index, subIndex, 'professor_id', valor)}
                                                                style={{
                                                                    col: {
                                                                        xs: 12,
                                                                        sm: 12,
                                                                        md: 12,
                                                                        lg: 12,
                                                                        xl: 12
                                                                    }
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col className="pr-2" style={{ flex: '1 0 0%' }}>
                                                            <SelectForm
                                                                label={`Local ${subIndex + 1}`}
                                                                name={`local_id_${index}_${subIndex}`}
                                                                placeholder="Selecione o Local"
                                                                options={locaisOptions}
                                                                value={locaisOptions?.find(option => option.value == linha.local_id) || ''}
                                                                onChange={(nome, valor) => atualizarLinhaProfessorLocal(index, subIndex, 'local_id', valor)}
                                                                style={{
                                                                    col: {
                                                                        xs: 12,
                                                                        sm: 12,
                                                                        md: 12,
                                                                        lg: 12,
                                                                        xl: 12
                                                                    }
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col xs="auto" style={{ paddingLeft: '5px' }}>
                                                            <FormGroup>
                                                                <Label className="invisible label-conteudoInferior label">Botoes</Label>
                                                                <div className="d-flex align-items-center" style={{ height: '38px' }}>
                                                                    <FiTrash2
                                                                        onClick={() => removerLinhaProfessorLocal(index, subIndex)}
                                                                        className="menuIconsReplica"
                                                                        title="Remover Professor"
                                                                        style={{ margin: 0, marginRight: '7px' }}
                                                                    />
                                                                    {subIndex === linhasGrupo.length - 1 && (
                                                                        <FiPlus
                                                                            onClick={() => adicionarLinhaProfessorLocal(index)}
                                                                            className="menuIconsReplica"
                                                                            title="Adicionar Professor"
                                                                            style={{ margin: 0 }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                ))}
                                            </div>
                                        );
                                    })()
                                }
                                <div className="linha-separadora-grupo my-3" />
                            </Col>
                        ))}
                    </Row>
                    <Row className={valoresFiltro?.qtd_alunos !== 0 ? 'exibir' : 'nao-exibir'}>
                        <Col className="align-content-middle">
                            <Button className="mx-3" onClick={() => toggle()}>Cancelar</Button>
                            <Button className="mx-3" onClick={() => salvar()}>Salvar</Button>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalCritiaGrupos
                    isOpen={modalCritica}
                    toggle={toggleModalCritica}
                    atualizarGrupos={atualizarGrupos}
                    dados={dados}
                />
            </Modal>
        </NewLoader>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao))
    };
};

export default connect(null, mapDispatchToProps)(ModalGruposAlunoServico);
